import { SVGProps } from 'react'

type Props = {
  id: string
  height?: number
  width?: number
  className?: string
} & SVGProps<SVGSVGElement>

export default function Icon({
  id,
  height = 40,
  width = 40,
  className = '',
  ...props
}: Props): JSX.Element {
  return (
    <svg width={width} height={height} className={className} {...props}>
      <use xlinkHref={`/assets/icons/icon-sprite.svg#${id}`} />
    </svg>
  )
}
